import { styled } from '@mui/material'

import { theme } from 'styles/theme'

export const NavBar = styled('nav')({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 900,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  height: '64px',
  paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 4px)',
  backgroundColor: '#ffffff',
  borderTop: `1px solid ${theme.palette.neutral[700]}`,
  boxShadow: '0 -2px 12px 0 rgba(0, 0, 0, 0.06)',
  '@media (min-width: 771px)': {
    display: 'none'
  }
})

interface NavItemProps {
  isActive?: boolean
}

export const NavItem = styled('button')<NavItemProps>(({ isActive }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
  flex: 1,
  height: '100%',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  padding: '8px 0',
  WebkitTapHighlightColor: 'transparent',
  transition: 'color 150ms ease',
  color: isActive ? theme.palette.primary.main : theme.palette.neutral[400],
  '& svg': {
    transition: 'color 150ms ease'
  }
}))

export const NavLabel = styled('span')<NavItemProps>(({ isActive }) => ({
  fontSize: '9px',
  fontWeight: isActive ? 600 : 500,
  lineHeight: 1,
  color: isActive ? theme.palette.primary.main : theme.palette.neutral[400],
  whiteSpace: 'nowrap',
  letterSpacing: '-0.01em'
}))
